import React from 'react'
import UploadPage from './Upload'

const Upload = () => (
    <UploadPage/>
)

export default Upload
